import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge, type BadgeProps } from '@/components/ui/badge';

/**
 * Provenance badge for an effective config value. The source answers the
 * operator's core question — "did I set this (DB), is it provisioned (ENV), or
 * is it the shipped default (CODE)?" — at a glance.
 */
export function SourceBadge({ source }: { readonly source: string }): ReactElement {
  const { t } = useTranslation();
  const variant: BadgeProps['variant'] =
    source === 'DB' ? 'default' : source === 'ENV' ? 'secondary' : 'outline';
  const label =
    source === 'DB'
      ? t('routes.admin.configs.source.db')
      : source === 'ENV'
        ? t('routes.admin.configs.source.env')
        : source === 'CODE'
          ? t('routes.admin.configs.source.code')
          : source;
  return <Badge variant={variant}>{label}</Badge>;
}
